import React, { useEffect } from "react";
import { Segment, Button, Form, Icon } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { initialize, Field, reduxForm, FieldArray } from "redux-form";
import { createRetailer } from "../../firebase";
import { TextInput } from "../../templates/utils/form-fields";

const FieldList = ({ fields, index }) => {
  return (
    <>
      <Form.Field>
        <Icon
          size="large"
          color="teal"
          onClick={() => fields.push({})}
          link
          name="plus"
          className="pushdown"
        />
      </Form.Field>
      {fields.map((template, index) => (
        <Form.Group key={index} className="clearboth">
          <Form.Field>
            <label>Name</label>
            <Field
              type="text"
              name={`${template}.name`}
              component={TextInput}
              value={template.name}
            />
          </Form.Field>
          <Form.Field>
            <label>Label</label>
            <Field
              type="text"
              name={`${template}.label`}
              component={TextInput}
              value={template.label}
            />
          </Form.Field>
          <Form.Field>
            <label>Width</label>
            <Field
              type="text"
              name={`${template}.width`}
              component={TextInput}
              value={template.width}
            />
          </Form.Field>
          <Form.Field>
            <label>Height</label>
            <Field
              type="text"
              name={`${template}.height`}
              component={TextInput}
              value={template.height}
            />
          </Form.Field>
          <Form.Field>
            <label>Max width</label>
            <Field
              type="text"
              name={`${template}.maxWidth`}
              component={TextInput}
              value={template.maxWidth}
            />
          </Form.Field>
          <Form.Field>
            <label>Density</label>
            <Field
              type="text"
              name={`${template}.density`}
              component={TextInput}
              value={template.density}
            />
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <Icon
              onClick={() => fields.remove(index)}
              link
              size="large"
              color="red"
              name="trash"
            />
          </Form.Field>
        </Form.Group>
      ))}
    </>
  );
};

let GamStandard = ({ retailer, id, handleSubmit, pristine, submitting }) => {
  const dispatch = useDispatch();

  const handleSubmitForm = (values) => {
    const update = { ...retailer };
    update.templates[id].fields = values.fields;
    createRetailer(update).then(() => {});
  };

  useEffect(() => {
    dispatch(initialize("standardForm", retailer.templates[id]));
  }, [dispatch, retailer, id]);

  return (
    <Segment>
      <Form onSubmit={handleSubmit(handleSubmitForm)}>
        <FieldArray name="fields" component={FieldList} />
        <Button
          className="clearboth"
          positive
          size="tiny"
          type="submit"
          disabled={submitting || pristine}
        >
          Submit
        </Button>
      </Form>
    </Segment>
  );
};

GamStandard = reduxForm({
  form: "standardForm",
})(GamStandard);

export default GamStandard;
